var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c("div", { staticClass: "image-upload-container" }, [
    _c(
      "div",
      { staticClass: "hint" },
      [_c("Hint", { attrs: { label: _vm.label, hint: _vm.hint } })],
      1
    ),
    _c(
      "div",
      {
        staticClass: "image-uploader",
        on: {
          dragover: function($event) {
            $event.preventDefault()
          },
          drop: function($event) {
            $event.preventDefault()
          }
        }
      },
      [
        _c("input", {
          ref: "imageInput",
          staticClass: "input-image",
          attrs: { type: "file", accept: _vm.allowedFormats.join(", ") },
          on: { change: _vm.uploadImageWithClick }
        }),
        _vm.previewUrl.trim() === ""
          ? _c(
              "label",
              {
                staticClass: "uploader-section",
                on: {
                  click: function($event) {
                    return _vm.$refs.imageInput.click()
                  },
                  drop: _vm.uploadImageWithDrop
                }
              },
              [
                _c("span", { staticClass: "uploader-label" }, [
                  _c("img", {
                    staticClass: "uploader-image",
                    attrs: {
                      src: require("@/drc/assets/icons/image-upload.svg"),
                      alt: "image"
                    }
                  }),
                  _c("span", [
                    _vm._v(_vm._s(_vm.$t("projectFroms.uploadFile")))
                  ])
                ])
              ]
            )
          : _vm._e(),
        _vm.previewUrl.trim() !== ""
          ? _c(
              "span",
              {
                class: [
                  "preview",
                  "large",
                  { "error-border": _vm.errors.length > 0 }
                ]
              },
              [
                _c("img", {
                  staticClass: "close",
                  attrs: {
                    src: require("@/drc/assets/icons/x-with-cicle.svg"),
                    width: "18",
                    height: "18",
                    alt: "close"
                  },
                  on: { click: _vm.removeImage }
                }),
                _c("img", {
                  ref: "imagePreview",
                  staticClass: "preview-image",
                  attrs: { src: _vm.previewUrl, alt: "logo" }
                })
              ]
            )
          : _vm._e(),
        _vm.errors.length > 0
          ? _c(
              "div",
              { staticClass: "image-upload-error" },
              _vm._l(_vm.errors, function(error, index) {
                return _c("p", { key: index, staticClass: "image-error" }, [
                  _vm._v(
                    " " +
                      _vm._s(
                        `${_vm.$t(`controlPanel.landingPage.errors.${error}`)}`
                      ) +
                      " "
                  )
                ])
              }),
              0
            )
          : _vm._e(),
        _c(
          "button",
          {
            class: [
              "apply-button",
              {
                "error-button":
                  _vm.errors.length > 0 || _vm.previewUrl.trim() === ""
              }
            ],
            on: { click: _vm.apply }
          },
          [_vm._v(" " + _vm._s(_vm.$t("controlPanel.landingPage.apply")) + " ")]
        )
      ]
    )
  ])
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }